module.exports = __webpack_public_path__ + "static/media/money-bill-alt.943b50d6.svg";